























































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Service from "@/services/MonitoringIntraOpLokalService";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus, slotTandaTanganDokumen } from "@/utils/hapusSetelahTtd";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";

function emptyVerifikasi() {
  return { identitas: false, consent: false, site_marking: "N/A", status_puasa: "N/A" };
}
function emptyAnamnesis() {
  return {
    alergi_ada: false, alergi_detail: "",
    riwayat_last: false,
    jantung: "", hati_ginjal: "", obat_rutin: "", kehamilan: ""
  };
}
function emptyTtv() {
  return { td_sistol: null, td_diastol: null, nadi: null, rr: null, suhu: null, spo2: null, nrs: null, gcs: "" };
}
function emptyTtvPost() {
  return { td_sistol: null, td_diastol: null, nadi: null, rr: null, spo2: null, nrs: null, kesadaran: "cm" };
}
function emptyEvaluasi() {
  return {
    sadar_penuh: false, ttv_stabil: false, tidak_perdarahan: false,
    tidak_last: false, luka_tertutup: false, edukasi: false
  };
}
function emptyEdukasi() {
  return { kontrol_tgl: "", resep: "", catatan: "" };
}

@Component({
  components: { PersonAutoComplete }
})
export default class MonitoringIntraOpLokalPage extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;

  loading = false;
  saving = false;
  recordId: number | null = null;
  data: any = {};
  existingList: any[] = [];

  form = {
    lokasi_tindakan: "ibs_ok",
    tanggal: localISODate(),
    jam_mulai: "",
    jam_selesai: "",
    bb_kg: null as number | null,
    tb_cm: null as number | null,
    diagnosis: "",
    icd10: "",
    tindakan: "",
    icd9cm: "",
    verifikasi: emptyVerifikasi(),
    anamnesis: emptyAnamnesis(),
    ttv_baseline: emptyTtv(),
    agen: null as string | null,
    agen_lain: "",
    konsentrasi_persen: null as number | null,
    volume_ml: null as number | null,
    vasokonstriktor: "tidak",
    teknik: null as string | null,
    teknik_detail: "",
    jam_mulai_injeksi: "",
    operator_injeksi_nama: "",
    last_surveillance: {} as Record<string, any>,
    ada_komplikasi: false,
    komplikasi: { jam: "", jenis: "", tindakan: [] as string[], detail: "" },
    lapor_ikp: false,
    ttv_post: emptyTtvPost(),
    evaluasi_klinis: emptyEvaluasi(),
    aldrete_dipakai: false,
    aldrete_aktivitas: null as number | null,
    aldrete_pernapasan: null as number | null,
    aldrete_sirkulasi: null as number | null,
    aldrete_kesadaran: null as number | null,
    aldrete_saturasi: null as number | null,
    status_pemulangan: null as string | null,
    pemulangan_detail: "",
    edukasi: emptyEdukasi(),
  };

  dosePreview: any = { dosis_maks_mg: null, persen_max: null, status_dosis: null, reference: null };

  ttvList: any[] = [];
  ttvDialog = {
    show: false,
    editingId: null as number | null,
    form: { jam: "", fase: "intra", td_sistol: null, td_diastol: null, nadi: null, rr: null, spo2: null, nrs: null, kesadaran: "cm", catatan: "" } as any,
  };

  signDialog = { show: false, role: "" as "operator" | "perawat" | "", password: "", busy: false };

  lokasiOptions = [
    { text: "IBS / OK (Minor Surgery)", value: "ibs_ok" },
    { text: "ODC (One Day Care)", value: "odc" },
    { text: "IGD", value: "igd" },
    { text: "Poli Bedah Minor", value: "poli_bedah" },
    { text: "Poli Gigi & Mulut", value: "poli_gigi" },
    { text: "Poli Mata", value: "poli_mata" },
    { text: "Poli THT", value: "poli_tht" },
    { text: "Poli Kulit & Kelamin", value: "poli_kulit" },
    { text: "Poli Obstetri & Ginekologi", value: "poli_obgyn" },
    { text: "Treatment Room", value: "treatment_room" },
  ];

  agenOptions = [
    { text: "Lidocaine", value: "lidocaine" },
    { text: "Mepivacaine", value: "mepivacaine" },
    { text: "Articaine", value: "articaine" },
    { text: "Bupivacaine", value: "bupivacaine" },
    { text: "Prilocaine", value: "prilocaine" },
    { text: "Lainnya", value: "lainnya" },
  ];

  vasoOptions = [
    { text: "Tidak ada", value: "tidak" },
    { text: "Epinefrin 1:80.000", value: "epi_1_80000" },
    { text: "Epinefrin 1:100.000", value: "epi_1_100000" },
    { text: "Epinefrin 1:200.000", value: "epi_1_200000" },
    { text: "Felipressin", value: "felipressin" },
  ];

  teknikOptions = [
    { text: "Infiltrasi", value: "infiltrasi" },
    { text: "Blok Saraf", value: "blok_saraf" },
    { text: "Topikal", value: "topikal" },
    { text: "Tumescent", value: "tumescent" },
    { text: "Field Block", value: "field_block" },
  ];

  kesadaranOptions = [
    { text: "CM (Compos Mentis)", value: "cm" },
    { text: "Apatis", value: "apatis" },
    { text: "Somnolen", value: "somnolen" },
    { text: "Sopor", value: "sopor" },
    { text: "Koma", value: "koma" },
  ];

  pemulanganOptions = [
    { text: "Pulang langsung (ODC)", value: "pulang_langsung" },
    { text: "Pulang dengan pengawasan keluarga", value: "pulang_pengawasan" },
    { text: "Pindah ke Ruang Rawat", value: "pindah_ranap" },
    { text: "Pindah ke RR (observasi)", value: "pindah_rr" },
    { text: "Pindah ke ICU/HCU", value: "pindah_icu_hcu" },
    { text: "Rujuk ke RS lain", value: "rujuk" },
    { text: "Lainnya", value: "lainnya" },
  ];

  lastKategori = [
    { key: "cns_early", short: "CNS Early", label: "CNS Early — tinitus, baal perioral, rasa logam", severe: false },
    { key: "cns_mid", short: "CNS Mid", label: "CNS Mid — dizziness, bingung, gelisah, twitching", severe: false },
    { key: "cns_severe", short: "CNS Severe", label: "CNS Severe — kejang, koma ⚠", severe: true },
    { key: "cv", short: "Cardiovascular", label: "CV — hipotensi, bradikardia, aritmia ⚠", severe: true },
    { key: "alergi", short: "Alergi", label: "Reaksi alergi — urtikaria, ruam, edema", severe: false },
    { key: "anafilaksis", short: "Anafilaksis", label: "Anafilaksis — sesak, stridor, syok ⚠", severe: true },
    { key: "vasovagal", short: "Vasovagal", label: "Vasovagal — pucat, keringat dingin, sinkop", severe: false },
    { key: "methemoglobinemia", short: "Methemoglobinemia", label: "Methemoglobinemia — sianosis tanpa hipoksia ⚠", severe: true },
    { key: "toks_epi", short: "Toks Epinefrin", label: "Toksisitas Epinefrin — takikardia, hipertensi mendadak", severe: false },
  ];

  tindakanKomplikasiOptions = [
    "STOP injeksi anestesi",
    "Posisi pasien (head-down jika sinkop)",
    "Oksigen suplemen",
    "Akses IV terpasang",
    "Resusitasi (ABC)",
    "Intralipid 20% (LAST berat)",
    "Adrenalin/Epinefrin IM (anafilaksis)",
    "Diazepam / Midazolam (kejang)",
    "Aktivasi Tim Code Blue",
    "Transfer ke ICU / OK / IGD",
    "Konsul DPJP Anestesi",
  ];

  evaluasiItems = [
    { key: "sadar_penuh", label: "Pasien sadar penuh, kooperatif" },
    { key: "ttv_stabil", label: "Tanda vital stabil" },
    { key: "tidak_perdarahan", label: "Tidak ada perdarahan aktif" },
    { key: "tidak_last", label: "Tidak ada reaksi LAST atau alergi" },
    { key: "luka_tertutup", label: "Area tindakan kering & tertutup dressing" },
    { key: "edukasi", label: "Edukasi pasca-prosedur diberikan" },
  ];

  ttvHeaders = [
    { text: "Jam", value: "jam", width: 80 },
    { text: "Fase", value: "fase", width: 80 },
    { text: "TD", value: "td", width: 90 },
    { text: "Nadi", value: "nadi", width: 60 },
    { text: "RR", value: "rr", width: 50 },
    { text: "SpO₂", value: "spo2", width: 60 },
    { text: "NRS", value: "nrs", width: 50 },
    { text: "Kesadaran", value: "kesadaran" },
    { text: "Catatan", value: "catatan" },
    { text: "", value: "actions", width: 80, sortable: false },
  ];

  // ==================== Lifecycle ====================

  mounted() {
    if (this.register) this.loadList();
  }

  // ==================== Computeds ====================

  get locked(): boolean {
    return !!(this.data && this.data.is_locked);
  }

  get canSave(): boolean {
    return !!this.form.lokasi_tindakan && !!this.form.tanggal;
  }

  get statusLabel(): string {
    const s = this.data?.status;
    return s === "selesai" ? "Selesai" : s === "sebagian" ? "Sebagian TTD" : "Draft";
  }

  get statusColor(): string {
    const s = this.data?.status;
    return s === "selesai" ? "green" : s === "sebagian" ? "orange" : "grey";
  }

  get totalDosisDisplay(): string {
    if (this.form.volume_ml == null || this.form.konsentrasi_persen == null) return "-";
    return ((this.form.volume_ml as number) * (this.form.konsentrasi_persen as number) * 10).toFixed(2);
  }

  get doseAlertType(): string {
    const s = this.dosePreview.status_dosis;
    if (s === "alert") return "error";
    if (s === "hati_hati") return "warning";
    if (s === "aman") return "success";
    return "info";
  }

  get statusDosisLabel(): string {
    const m: Record<string, string> = { aman: "AMAN", hati_hati: "HATI-HATI", alert: "ALERT (≥100%)" };
    return m[this.dosePreview.status_dosis] || "-";
  }

  get aldreteTotal(): number {
    if (!this.form.aldrete_dipakai) return 0;
    return (this.form.aldrete_aktivitas || 0)
      + (this.form.aldrete_pernapasan || 0)
      + (this.form.aldrete_sirkulasi || 0)
      + (this.form.aldrete_kesadaran || 0)
      + (this.form.aldrete_saturasi || 0);
  }

  get durasiLabel(): string {
    const m = this.form.jam_mulai, s = this.form.jam_selesai;
    if (!m || !s) return "-";
    const [mh, mm] = m.split(":").map(Number);
    const [sh, sm] = s.split(":").map(Number);
    const diff = (sh * 60 + sm) - (mh * 60 + mm);
    return diff > 0 ? `${diff} mnt` : "-";
  }

  get frekuensiHint(): string {
    const m = this.form.jam_mulai, s = this.form.jam_selesai;
    if (!m || !s) return "Frekuensi: baseline + mid + akhir";
    const [mh, mm] = m.split(":").map(Number);
    const [sh, sm] = s.split(":").map(Number);
    const diff = (sh * 60 + sm) - (mh * 60 + mm);
    if (diff <= 0) return "Frekuensi: baseline + mid + akhir";
    if (diff < 30) return "Frekuensi: baseline + mid + akhir (prosedur < 30 mnt)";
    if (diff < 60) return "Frekuensi: tiap 15 menit (prosedur 30–60 mnt)";
    return "Frekuensi: tiap 10–15 menit (prosedur > 60 mnt)";
  }

  get lastAlertCount(): number {
    const cnsCvKeys = ["cns_mid", "cns_severe", "cv", "anafilaksis", "methemoglobinemia"];
    return cnsCvKeys.filter(k => !!this.form.last_surveillance[k]).length;
  }

  get existingListItems() {
    return this.existingList.map(it => ({
      value: it.id,
      text: `#${it.id} · ${it.tanggal} · ${it.tindakan || it.diagnosis || "(tanpa label)"} · ${it.status}`,
    }));
  }

  // ==================== Loaders ====================

  async loadList() {
    this.loading = true;
    try {
      const res = await Service.getByRegister(this.register);
      const arr = res?.data?.data || [];
      this.existingList = arr;
      if (arr.length) {
        await this.loadRecord(arr[0].id);
      }
    } finally {
      this.loading = false;
    }
  }

  async loadRecord(id: number) {
    this.loading = true;
    try {
      const res = await Service.find(id);
      const d = res?.data?.data;
      if (d) {
        this.recordId = d.id;
        this.data = d;
        this.populateForm(d);
        this.ttvList = d.ttvs || [];
        this.recalcDose();
      }
    } finally {
      this.loading = false;
    }
  }

  populateForm(d: any) {
    // Scalar fields
    const scalarKeys: string[] = [
      "lokasi_tindakan", "tanggal", "jam_mulai", "jam_selesai",
      "bb_kg", "tb_cm", "diagnosis", "icd10", "tindakan", "icd9cm",
      "agen", "agen_lain", "konsentrasi_persen", "volume_ml",
      "vasokonstriktor", "teknik", "teknik_detail", "jam_mulai_injeksi",
      "operator_injeksi_nama",
      "ada_komplikasi", "lapor_ikp",
      "aldrete_dipakai", "aldrete_aktivitas", "aldrete_pernapasan",
      "aldrete_sirkulasi", "aldrete_kesadaran", "aldrete_saturasi",
      "status_pemulangan", "pemulangan_detail",
    ];
    scalarKeys.forEach(k => {
      if (d[k] !== undefined && d[k] !== null) (this.form as any)[k] = d[k];
    });
    if (d.tanggal && typeof d.tanggal === "string" && d.tanggal.length >= 10) {
      this.form.tanggal = d.tanggal.slice(0, 10);
    }
    // Trim H:i:s -> H:i for time inputs
    ["jam_mulai", "jam_selesai", "jam_mulai_injeksi"].forEach(k => {
      const v = (this.form as any)[k];
      if (typeof v === "string" && v.length >= 5) (this.form as any)[k] = v.slice(0, 5);
    });

    // Nested JSON fields
    this.form.verifikasi = { ...emptyVerifikasi(), ...(d.verifikasi || {}) };
    this.form.anamnesis = { ...emptyAnamnesis(), ...(d.anamnesis || {}) };
    this.form.ttv_baseline = { ...emptyTtv(), ...(d.ttv_baseline || {}) };
    this.form.last_surveillance = { ...(d.last_surveillance || {}) };
    this.form.komplikasi = {
      jam: "", jenis: "", tindakan: [], detail: "",
      ...(d.komplikasi || {}),
    };
    // Komplikasi.tindakan should always be an array
    if (!Array.isArray(this.form.komplikasi.tindakan)) this.form.komplikasi.tindakan = [];
    this.form.ttv_post = { ...emptyTtvPost(), ...(d.ttv_post || {}) };
    this.form.evaluasi_klinis = { ...emptyEvaluasi(), ...(d.evaluasi_klinis || {}) };
    this.form.edukasi = { ...emptyEdukasi(), ...(d.edukasi || {}) };
  }

  // ==================== Actions ====================

  getUnitId(): string {
    const reg = RegisterKunjungan.register;
    if (reg && (reg as any).jurnal_ranap && (reg as any).jurnal_ranap.length) {
      const last = (reg as any).jurnal_ranap[(reg as any).jurnal_ranap.length - 1];
      if (last && last.unit) return last.unit.id;
    }
    if (reg && (reg as any).unit && (reg as any).unit.id) return (reg as any).unit.id;
    return (this.$route as any)?.query?.unit_id || "";
  }

  getPayload() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.getUnitId(),
      ...this.form,
    };
  }

  async save() {
    this.saving = true;
    try {
      const res = this.recordId
        ? await Service.update(this.recordId, this.getPayload())
        : await Service.create(this.getPayload());
      const d = res?.data?.data;
      if (d) {
        this.recordId = d.id;
        this.data = d;
        this.populateForm(d);
        this.ttvList = d.ttvs || [];
        await this.loadList();
      }
    } finally {
      this.saving = false;
    }
  }

  get bisaHapus(): boolean {
    if (!this.recordId) return false;
    return !alasanTtdMengunciHapus(
      this.data.user_id,
      [
        ...slotTandaTanganDokumen(this.data.signed_operator, this.data.signature_operator),
        ...slotTandaTanganDokumen(this.data.signed_perawat, this.data.signature_perawat)
      ],
      userModule.user?.id
    );
  }

  async remove() {
    if (!this.bisaHapus) return;
    if (!this.recordId) return;
    if (!confirm("Hapus sesi monitoring ini? Tidak dapat dipulihkan jika sudah ada TTD.")) return;
    await Service.destroy(this.recordId);
    this.newRecord();
    await this.loadList();
  }

  newRecord() {
    this.recordId = null;
    this.data = {};
    this.ttvList = [];
    this.form = {
      ...this.form,
      lokasi_tindakan: this.form.lokasi_tindakan,
      tanggal: localISODate(),
      jam_mulai: "", jam_selesai: "",
      bb_kg: null, tb_cm: null, diagnosis: "", icd10: "", tindakan: "", icd9cm: "",
      verifikasi: emptyVerifikasi(),
      anamnesis: emptyAnamnesis(),
      ttv_baseline: emptyTtv(),
      agen: null, agen_lain: "", konsentrasi_persen: null, volume_ml: null,
      vasokonstriktor: "tidak", teknik: null, teknik_detail: "",
      jam_mulai_injeksi: "", operator_injeksi_nama: "",
      last_surveillance: {},
      ada_komplikasi: false,
      komplikasi: { jam: "", jenis: "", tindakan: [], detail: "" },
      lapor_ikp: false,
      ttv_post: emptyTtvPost(),
      evaluasi_klinis: emptyEvaluasi(),
      aldrete_dipakai: false,
      aldrete_aktivitas: null, aldrete_pernapasan: null,
      aldrete_sirkulasi: null, aldrete_kesadaran: null, aldrete_saturasi: null,
      status_pemulangan: null, pemulangan_detail: "",
      edukasi: emptyEdukasi(),
    };
    this.dosePreview = { dosis_maks_mg: null, persen_max: null, status_dosis: null, reference: null };
  }

  printPdf() {
    if (this.recordId) Service.print(this.recordId);
  }

  // ==================== Dose preview ====================

  recalcDose() {
    const totalDosis = (this.form.volume_ml != null && this.form.konsentrasi_persen != null)
      ? Number(this.form.volume_ml) * Number(this.form.konsentrasi_persen) * 10
      : null;
    Service.calculateDose({
      agen: this.form.agen,
      bb_kg: this.form.bb_kg,
      total_dosis_mg: totalDosis,
      vasokonstriktor: this.form.vasokonstriktor,
      volume_ml: this.form.volume_ml,
      konsentrasi_persen: this.form.konsentrasi_persen,
    }).then(res => {
      this.dosePreview = res?.data?.data || {};
    }).catch(() => { /* silently ignore — server-side recalc on save */ });
  }

  @Watch("form.bb_kg")
  onBbChange() { this.recalcDose(); }

  // ==================== TTV ====================

  openTtvDialog() {
    this.ttvDialog.editingId = null;
    this.ttvDialog.form = { jam: "", fase: this.ttvList.length === 0 ? "baseline" : "intra",
      td_sistol: null, td_diastol: null, nadi: null, rr: null, spo2: null, nrs: null,
      kesadaran: "cm", catatan: "" };
    this.ttvDialog.show = true;
  }

  editTtv(item: any) {
    this.ttvDialog.editingId = item.id;
    this.ttvDialog.form = {
      jam: (item.jam || "").slice(0, 5),
      fase: item.fase || "intra",
      td_sistol: item.td_sistol, td_diastol: item.td_diastol,
      nadi: item.nadi, rr: item.rr, spo2: item.spo2, nrs: item.nrs,
      kesadaran: item.kesadaran || "cm", catatan: item.catatan || "",
    };
    this.ttvDialog.show = true;
  }

  async saveTtv() {
    if (!this.recordId) return;
    const payload = { ...this.ttvDialog.form };
    if (this.ttvDialog.editingId) {
      await Service.updateTtv(this.recordId, this.ttvDialog.editingId, payload);
    } else {
      await Service.addTtv(this.recordId, payload);
    }
    this.ttvDialog.show = false;
    await this.loadRecord(this.recordId);
  }

  async removeTtv(item: any) {
    if (!this.recordId) return;
    if (!confirm("Hapus pencatatan TTV ini?")) return;
    await Service.deleteTtv(this.recordId, item.id);
    await this.loadRecord(this.recordId);
  }

  kesadaranLabel(v: string): string {
    const f = this.kesadaranOptions.find(x => x.value === v);
    return f ? f.text.split(" ")[0] : "-";
  }

  // ==================== Sign ====================

  openSignDialog(role: "operator" | "perawat") {
    this.signDialog.role = role;
    this.signDialog.password = "";
    this.signDialog.show = true;
  }

  async confirmSign() {
    if (!this.recordId || !this.signDialog.role) return;
    this.signDialog.busy = true;
    try {
      const fn = this.signDialog.role === "operator" ? Service.signOperator : Service.signPerawat;
      await fn(this.recordId, { password: this.signDialog.password });
      this.signDialog.show = false;
      await this.loadRecord(this.recordId);
    } finally {
      this.signDialog.busy = false;
    }
  }
}
